import { h, Component } from "preact";
import Picture from "./Picture";
import RichTextDisplay from "./RichTextDisplay";
import { personalize } from "../utils/Personalize";
import { css } from "emotion";

const EventMessage = ({ event, order }) => {
  const wrapper = css({
    maxWidth: 800,
    textAlign: "left",
    padding: 32,
    backgroundColor: "#fff",
    boxShadow: "0 1px 10px 2px rgba(32, 7, 64, 0.13)",
    borderRadius: 4,
    margin: "0 auto",
    marginBottom: 20,
    "@media(max-width: 800px)": {
      padding: 12
    }
  });
  if (!event || !event.messages || !event.messages.orderMessage) {
    return null;
  }

  const firstNameForRegex = order.firstName;
  const lastNameForRegex = order.lastName;
  const eventNameForRegex = event.name;

  return (
    <div className={wrapper}>
      <h2>Message from the organiser</h2>
      <RichTextDisplay
        html={personalize(
          event.messages.orderMessage,
          firstNameForRegex,
          lastNameForRegex,
          eventNameForRegex
        )}
      />
    </div>
  );
};
export default EventMessage;



// WEBPACK FOOTER //
// ./components/EventMessage.js